export default class DisplayRequirements {
  public list: any;

  public operator: string;

  constructor(params: any) {
    params = Array.isArray(params) ? params : [params];

    this.operator = DisplayRequirements.getOperator(params);

    const list = DisplayRequirements.getList(params);
    this.list = list.map((element) => {
      if (Array.isArray(element)) {
        return new DisplayRequirements(element);
      }
      return element;
    });
  }

  static getOperator(params: any): string {
    const operator = params.filter((row) => {
      if (row.operator) {
        return true;
      }
      return false;
    });
    if (operator.length) {
      return operator[0].operator;
    }
    return 'AND';
  }

  static getList(params: any): any[] {
    return params.filter((row) => {
      if (row.operator) {
        return false;
      }
      return true;
    });
  }
}
